module.exports = __webpack_public_path__ + "img/LEAN.3e626273.svg";